module.exports = __webpack_public_path__ + "static/media/DoubleTick.26fda6be.svg";